import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit, inject } from '@angular/core';

import * as rxjs from 'rxjs';
import { Observable } from 'rxjs';
import { delay } from 'rxjs/operators';
import { NavigationService } from './navigation.service';

@Component({
    selector: 'app-title',
    templateUrl: './app-title.component.html',
    styleUrls: ['./app-title.component.scss'],
    standalone: false
})
export class AppTitleComponent implements OnInit {
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly navigationSerice = inject(NavigationService);


  appTitle: Observable<string> = rxjs.NEVER;

  ngOnInit() {
    this.handleSizeChange();
    this.breakpointObserver.observe([Breakpoints.Handset,
    Breakpoints.Tablet, Breakpoints.Web]).subscribe(_v => {
      this.handleSizeChange();
    });

    this.appTitle = this.navigationSerice.getTitle().pipe(
      delay(0)
    );

  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  handleSizeChange() {
  }
}
